
(function() {
  var result = { translations: { "sk": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} hod.", "hoursAndMinutes": "{{ hours }} hod. {{ minutes }} min.", "days": "{{ days }} d.", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} hod.", "days": "{{ days }} d.", "hoursAndMinutes": "{{ hours }} hod. {{ minutes }} min." } }, "dateTime": { "quarterAndYear": "Kvart\xE1l {{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, klapka {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "sk": "static-7.1375"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1375",
    "ar-eg": "static-7.1375",
    "bg": "static-7.1375",
    "bn": "static-7.1375",
    "ca-es": "static-7.1375",
    "cs": "static-7.1375",
    "da": "static-7.1375",
    "de": "static-7.1375",
    "el": "static-7.1375",
    "en-gb": "static-7.1375",
    "en": "static-7.1375",
    "es-mx": "static-7.1375",
    "es": "static-7.1375",
    "et": "static-7.1375",
    "fi": "static-7.1375",
    "fr-ca": "static-7.1375",
    "fr": "static-7.1375",
    "he-il": "static-7.1375",
    "hi": "static-7.1375",
    "hr": "static-7.1375",
    "hu": "static-7.1375",
    "id": "static-7.1375",
    "it": "static-7.1375",
    "ja": "static-7.1375",
    "ko": "static-7.1375",
    "lt": "static-7.1375",
    "ms": "static-7.1375",
    "nl": "static-7.1375",
    "no": "static-7.1375",
    "pl": "static-7.1375",
    "pt-br": "static-7.1375",
    "pt-pt": "static-7.1375",
    "ro": "static-7.1375",
    "ru": "static-7.1375",
    "sk": "static-7.1375",
    "sl": "static-7.1375",
    "sv": "static-7.1375",
    "th": "static-7.1375",
    "tl": "static-7.1375",
    "tr": "static-7.1375",
    "uk": "static-7.1375",
    "vi": "static-7.1375",
    "x-pseudo": "static-7.1375",
    "zh-cn": "static-7.1375",
    "zh-hk": "static-7.1375",
    "zh-tw": "static-7.1375"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sk', {version: 'static-7.1375'}); }
})();


